import { combineReducers } from 'redux';

import { reducer as authenticate } from './authenticateModule';

export default combineReducers({
	authenticate,
});
